export const RolesWhiteList = {
  SPO_VISUALIZATION: 'SPO_OFFER_VISUALISATION',
  SPO_PRODUCT_LEADER: 'SPO_PRODUCT_LEADER',
  SPO_INTERNATIONAL_SPORT_LEADER: 'SPO_INTERNATIONAL_SPORT_LEADER',
  ADMIN: 'SPO_ADMIN_SUPPORT',
} as const

export interface RolesContextType {
  hasRoleVisualization: boolean
  hasRoleProductLeader: boolean
  hasRoleSportLeader: boolean
}
